import { useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n";
import { Button } from "./ui/button";
import { Cookie } from "lucide-react";

export const CookieBanner = () => {
  const { t } = useLang();
  const [visible, setVisible] = useState(!localStorage.getItem("liveq_cookie_consent"));

  const choose = (value) => {
    localStorage.setItem("liveq_cookie_consent", value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div data-testid="cookie-banner" className="fixed bottom-4 left-4 z-50 max-w-sm bg-zinc-900/95 backdrop-blur border border-zinc-800 rounded-2xl p-5 shadow-2xl">
      <div className="flex items-start gap-3">
        <Cookie size={18} className="text-emerald-400 mt-0.5 shrink-0" />
        <div>
          <p className="text-xs text-zinc-300 leading-relaxed">
            {t("cookie_text")}{" "}
            <Link to="/privacy" data-testid="cookie-privacy-link" className="text-emerald-400 hover:text-emerald-300 underline">
              {t("cookie_more")}
            </Link>
          </p>
          <div className="flex gap-2 mt-3">
            <Button data-testid="cookie-accept-btn" size="sm" onClick={() => choose("accepted")}
              className="rounded-full bg-emerald-600 hover:bg-emerald-500 text-white h-8 text-xs px-4">
              {t("cookie_accept")}
            </Button>
            <Button data-testid="cookie-decline-btn" size="sm" variant="outline" onClick={() => choose("essential")}
              className="rounded-full border-zinc-700 text-zinc-400 hover:bg-zinc-800 hover:text-white bg-transparent h-8 text-xs px-4">
              {t("cookie_decline")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
